export const PAGELOAD = "bathroom design services"
export const DESIGNSERVICES = "design services credit details"
